import { BANNED_MESSAGE } from "./roles.js";

// The words shown in the redeem box when redeeming points fails. Pure, so each answer of the API has a test.
// The API tells a phone-only account (no email to give the coupon to) apart with the code EMAIL_REQUIRED and its own message.
export function redeemFailureMessage(err, { shortBy = 0 } = {}) {
  if (err?.code === "EMAIL_REQUIRED") {
    return err.message || "Add an email to your account to redeem points";
  }
  let message = err?.message || "Failed to redeem RoamPoints";
  if (err?.status === 400) {
    message = err.details?.error || "Invalid product or amount selected.";
  } else if (err?.status === 402) {
    message = shortBy > 0 ? `You need ${shortBy} more RoamPoints.` : "You need more RoamPoints.";
  } else if (err?.code === "USER_BANNED") {
    // Do not retry: the account can still read, nothing else.
    message = BANNED_MESSAGE;
  } else if (err?.status === 502 || err?.code === "FUNNEL_UNAVAILABLE") {
    // No coupon, and Confirm stays enabled so they can try again.
    message = "Please try again later. Your points were not used.";
  } else if (err?.status === 500) {
    const couponCode = err.details?.couponCode || err.details?.code;
    message = couponCode
      ? `Something went wrong. Contact support with this ID: ${couponCode}`
      : "Something went wrong. Please contact support.";
  }
  return message;
}
